import { useEffect, useState } from "react";
import { api, formatBRL } from "@/lib/api";

export default function AdminCustomers() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/admin/customers").then((r) => setList(r.data || []));
  }, []);

  return (
    <div>
      <div className="overline-label">Base</div>
      <h1 className="font-display text-4xl text-white tracking-tighter mt-3 mb-8">Clientes</h1>
      <div className="border border-white/10 bg-[#0A0A0C] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-widest text-zinc-500">
            <tr>
              <th className="text-left px-4 py-3">Nome</th>
              <th className="text-left px-4 py-3">E-mail</th>
              <th className="text-left px-4 py-3">WhatsApp</th>
              <th className="text-right px-4 py-3">Pedidos</th>
              <th className="text-right px-4 py-3">Total gasto</th>
              <th className="text-left px-4 py-3">Último</th>
            </tr>
          </thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.email} className="border-t border-white/5" data-testid={`customer-${c.email}`}>
                <td className="px-4 py-3 text-white">{c.name}</td>
                <td className="px-4 py-3 text-zinc-300">{c.email}</td>
                <td className="px-4 py-3 text-zinc-400">{c.whatsapp}</td>
                <td className="px-4 py-3 text-right">{c.orders}</td>
                <td className="px-4 py-3 text-right font-display">{formatBRL(c.total_spent)}</td>
                <td className="px-4 py-3 text-xs text-zinc-500">{c.last_order && new Date(c.last_order).toLocaleDateString("pt-BR")}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="6" className="px-4 py-16 text-center text-zinc-500">Ainda sem clientes.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
